var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row data-picker"},[_c('div',{staticClass:"col-sm-12 form-group"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group datepicker-container"},[_c('input',{staticStyle:{"position":"absolute","visibility":"hidden"},attrs:{"id":"datepicker-input","type":"text","value":""}})])])])])
}]

export { render, staticRenderFns }